export const PERCORSOTARIFFA = 'PERCORSOTARIFFA'